import { render, staticRenderFns } from "./afr.vue?vue&type=template&id=61030d65&scoped=true"
import script from "./afr.vue?vue&type=script&lang=js"
export * from "./afr.vue?vue&type=script&lang=js"
import style0 from "./afr.vue?vue&type=style&index=0&id=61030d65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61030d65",
  null
  
)

export default component.exports